{
  "guidance.manager.title": "Planlama gerekçeleri",
  "guidance.manager.description": "Gelecekteki yeniden planlamayı yönlendiren gerekçeleri, koruma kurallarını ve asgari sınırları gözden geçirin.",
  "guidance.manager.error": "Planlama gerekçesi değiştirilemedi.",
  "guidance.manager.protected": "Korumalı",
  "guidance.manager.noPurpose": "Henüz bir amaç kaydedilmedi.",
  "guidance.manager.updated": "{{date}} tarihinde güncellendi · vazgeçme sırası {{order}}",
  "guidance.manager.editAction": "Gerekçeyi düzenle",
  "guidance.manager.closeEditor": "Düzenleyiciyi kapat",
  "guidance.manager.deleteAction": "Kalıcı olarak sil",
  "guidance.manager.deleteTitle": "Bu planlama gerekçesi kalıcı olarak silinsin mi?",
  "guidance.manager.deleteDescription": "Bu {{subject}} için yazılan açık gerekçe kaldırılacak. Varsa üst yapıdan devralınan gerekçe geçerli olacak.",
  "guidance.manager.cancelAction": "Vazgeç",
  "guidance.manager.saveAction": "Değişiklikleri kaydet",
  "guidance.manager.emptyTitle": "Açık bir planlama gerekçesi yok",
  "guidance.manager.emptyDescription": "Amacının yeniden planlama sırasında korunması gereken bir dönem, proje, hedef, görev, rutin, plan veya karardan gerekçe ekleyin.",
  "guidance.subject.span": "Dönem",
  "guidance.subject.project": "Proje",
  "guidance.subject.plan": "Plan",
  "guidance.subject.goal": "Hedef",
  "guidance.subject.task": "Görev",
  "guidance.subject.routine": "Rutin",
  "guidance.subject.decision": "Karar",
  "guidance.flexibility.fixed": "Sabit",
  "guidance.flexibility.anchored": "Çapalı",
  "guidance.flexibility.shiftable": "Taşınabilir",
  "guidance.flexibility.droppable": "Vazgeçilebilir",
  "guidance.field.purpose": "Neden var",
  "guidance.field.durationReason": "Neden bu süre",
  "guidance.field.timingReason": "Neden şimdi",
  "guidance.field.costOfSkipping": "Atlamanın bedeli",
  "guidance.field.expectedGain": "Beklenen kazanım",
  "guidance.field.successSignal": "Başarı sinyali",
  "guidance.field.abandonSignal": "Vazgeçme sinyali",
  "guidance.field.minimumViable": "Asgari uygulanabilir sürüm",
  "guidance.field.flexibility": "Esneklik",
  "guidance.field.sacrificeOrder": "Vazgeçme sırası",
  "guidance.field.protected": "Yeniden planlamada koru",
  "guidance.field.protectedHint": "Bu öğeyi taşımak için korumanın bilinçli olarak geçersiz kılınması gerekir."
}
